import "./btnScroll.css";
import arrowDownIcon from "../../assets/img/flecha-scroll.svg";

const BtnScroll = () => {
  return (
    <div className="container_scroll">
      <a href="#root">
        <img id="arrow-image" src={arrowDownIcon} />
      </a>
    </div>
  );
};
export default BtnScroll;
